'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeisAdjudicators = undefined;

var _getFeisAdjudicators2 = require('./getFeisAdjudicators');

var _getFeisAdjudicators3 = _interopRequireDefault(_getFeisAdjudicators2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getFeisAdjudicators = _getFeisAdjudicators3.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/adjudicators/index.js
// module id = 148
// module chunks = 0